export default __webpack_public_path__ + "static/media/General's Helm of the Shining Sun.f2f7d0d5.jpg";